module.exports = __webpack_public_path__ + "media/greenhouse-fullhd06.2e5d1684.mp4";